import { get } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import ReturnsPageCountrySelectorContainer from 'containers/ReturnsPageCountrySelectorContainer';
import Log from 'utils/Log';

const ReturnsController = class {
  static get countrySelectorData() {
    const data = get(window, ['ALLBIRDS', 'countrySelector']);

    if (!data) {
      Log.error(
        new Error(
          'Controllers:ReturnsController.countrySelectorData -- missing country selector data!'
        )
      );
    }

    return data;
  }

  static renderReturnsPageCountrySelector = store => {
    const domElement = document.getElementById('returns-country-selector-container');
    if (domElement) {
      ReactDOM.render(
        <Provider store={store}>
          <ReturnsPageCountrySelectorContainer {...ReturnsController.countrySelectorData} />
        </Provider>,
        domElement
      );
    }
  };

  static init = store => {
    ReturnsController.renderReturnsPageCountrySelector(store);
  };
};

export default ReturnsController;
